<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-container>
            <v-card>
               <v-form v-model="valid">
                  <v-container grid-list-md>
                     <v-layout wrap>

                        <v-flex xs12 sm6>
                           <v-select
                              label="Type"
                              v-model="question.type"
                              :items="types"
                              item-text="name"
                              item-value="uid"
                              @change="onChanged"
                           ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6>
                           <v-select
                              label="Niveau"
                              v-model="question.level"
                              :items="levels"
                              item-text="name"
                              item-value="uid"
                              @change="onChanged"
                           ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6>
                           <v-select
                              label="Diabète"
                              :value="diabetesStringToList(question.diabete)"
                              multiple
                              chips
                              :items="diabetes"
                              item-text="name"
                              item-value="uid"
                              @change="onDiabetesChanged(question, $event)"
                           ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6>
                           <v-select
                              label="Cholestérol"
                              :value="cholesterolStringToList(question.chol)"
                              multiple
                              chips
                              :items="cholesterols"
                              item-text="short"
                              item-value="uid"
                              @change="onCholesterolChanged(question, $event)"
                           ></v-select>
                        </v-flex>

                        <v-flex xs12 v-if="question.type !== 'intruder'">
                           <v-textarea
                              v-if="question.type !== 'intruder'"
                              label="Libellé question"
                              v-model="question.question"
                              :rules="requiredRules"
                              @input="onChanged"
                           ></v-textarea>
                        </v-flex>

                        <v-flex xs12>
                           <v-text-field
                              label="Note"
                              v-model="question.note"
                              @input="onChanged"
                           ></v-text-field>
                        </v-flex>

                        <v-flex xs12 v-if="question.type === 'truefalse'">
                           <div class="title">Images illustratives</div>
                           <v-layout column wrap>
                              <div v-for="image in images">
                                 <img
                                    :src="'/static/media/' + image.pict"
                                    width="150"
                                 />
                              </div>
                           </v-layout>
                        </v-flex>

                        <v-flex xs12>
                           <div class="title">Choix proposés</div>
                           <div v-for="item in items">
                              <img
                                 v-if="item.pict"
                                 :src="'/static/media/' + item.pict"
                                 width="150"
                              />
                              <div>{{ item.proposition }}</div>
                              <div>{{ item.answer }}</div>
                              <v-spacer></v-spacer>
                           </div>
                        </v-flex>

                        <v-flex xs12>
                           <v-btn @click="create" v-if="questionId === 0" :disabled="!dirty || !valid" flat style="width: 100%;">Créer</v-btn>
                           <v-btn @click="update" v-if="questionId !== 0" :disabled="!dirty || !valid" flat style="width: 100%;">Enregistrer</v-btn>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-form>
            </v-card>
         </v-container>
      </v-flex>

   </v-layout>
</template>


<script>
   import qcuConstants from '@/utilities/qcuConstants.js'

   export default {
      props: {
         questionId: Number,
      },

      data () {
         return {
            valid: false,
            dirty: false,
            requiredRules: [
               (v) => !!v || 'Ce champ est obligatoire',
            ],
         }
      },

      computed: {
         question () {
            // question changed : form is not dirty
            this.dirty = false
            if (this.questionId > 0) {
               // Vuex question
               let question = this.$store.getters['nutrikiosk/qcuQuestions'][this.questionId]
               // form operates on a clone of Vuex question (otherwise, direct store change)
               return _.clone(question)
            } else {
               return {
                  type: null,
                  level: null,
                  question: '',
                  }
            }
         },
         images () {
            return this.$store.state.nutrikiosk.qcuQuestion2qcuImageList[this.questionId].map(qcuImageId => this.$store.state.nutrikiosk.qcuImages[qcuImageId])
         },
         items () {
            return this.$store.state.nutrikiosk.qcuQuestion2qcuItemList[this.questionId].map(qcuItemId => this.$store.state.nutrikiosk.qcuItems[qcuItemId])
         },
         types () {
            return qcuConstants.typeList.map(uid => qcuConstants.types[uid])
         },
         levels () {
            return qcuConstants.levelList.map(uid => qcuConstants.levels[uid])
         },
         diabetes () {
            return qcuConstants.diabetesList.map(uid => qcuConstants.diabetes[uid])
         },
         cholesterols () {
            return qcuConstants.cholesterolList.map(uid => qcuConstants.cholesterols[uid])
         },
      },

      methods: {
         onChanged: function() {
            this.dirty = true
         },
         create: function() {
            this.$emit('createQuestion', this.question)
         },
         update: function() {
            this.$emit('updateQuestion', this.question)
         },
         diabetesStringToList: function(str) {
            let list = []
            if (str.indexOf('0') !== -1) list.push('nodiabetes')
            if (str.indexOf('1') !== -1) list.push('type1')
            if (str.indexOf('2') !== -1) list.push('type2')
            return list
         },
         diabetesListToString: function(list) {
            let str = ''
            if (list.indexOf('nodiabetes') !== -1) str += '0'
            if (list.indexOf('type1') !== -1) str += '1'
            if (list.indexOf('type2') !== -1) str += '2'
            return str
         },
         onDiabetesChanged: function(question, list) {
            this.dirty = true
            question.diabete = this.diabetesListToString(list)
         },
         cholesterolStringToList: function(str) {
            let list = []
            if (str.indexOf('0') !== -1) list.push('no')
            if (str.indexOf('1') !== -1) list.push('yes')
            return list
         },
         cholesterolListToString: function(list) {
            let str = ''
            if (list.indexOf('no') !== -1) str += '0'
            if (list.indexOf('yes') !== -1) str += '1'
            return str
         },
         onCholesterolChanged: function(question, list) {
            this.dirty = true
            question.chol = this.cholesterolListToString(list)
         },
      },
   }
</script>




// WEBPACK FOOTER //
// QCUQuestion.vue?72be0f59